<script setup lang="ts">
    import { Button } from '@/components/ui/button';
    import { Trash2 } from 'lucide-vue-next';

    const props = defineProps<{
        buttonText?: string;
    }>();
</script>

<template>
    <Button
        variant="delete"
        size="xs"
    >
        <span>{{ buttonText || $t('tables.delete') }}</span>
        <Trash2 class="size-3" />
    </Button>
</template>
